import { code } from "@spscommerce/utils";

export const SpsTaskQueueExamples = {
  basic: {
    label: "Task Queue in progress",
    description:
      "<p>Info about Task Queue</p>",
    examples: {
      basic: {
        template: code`
        <sps-task-queue [(tasks)]="tasks" (opened)="onOpen()" (completedCleared)="onClearCompleted($event)"></sps-task-queue>
        `,
        class: code`
        class DemoComponent {
            tasks: SpsTask[] = [
                {
                    status: SpsTaskStatus.IN_PROGRESS,
                    unread: false,
                    heading: "Downloading 245 transactions",
                    subheading: "processing…",
                    actions: [this.cancel],
                },
                {
                    status: SpsTaskStatus.COMPLETED,
                    unread: true,
                    heading: "Document Download - 02/21/2019",
                    subheading: "245 transactions | Expires in 2 days",
                    actions: [this.view, this.download],
                },
                {
                    status: SpsTaskStatus.ERRORED,
                    unread: true,
                    heading: "Data XREF Test.xls",
                    subheading: "Failed | Reason it failed…",
                    actions: [this.retry],
                }
            ];

            onClearCompleted(clearedTasks) {
                console.log(clearedTasks);
                console.log(this.tasks);
            }

            @SpsAction({ icon: "x" })
            cancel(task) {
                console.log("cancel", task);
            }

            @SpsAction({ icon: "search" })
            view(task) {
                console.log("view", task);
            }

            @SpsAction({ icon: "download-cloud" })
            download(task) {
                console.log("download", task);
            }

            @SpsAction({ icon: "refresh" })
            retry(task) {
                console.log("retry", task);
            }

            onOpen() {
                console.log("opened");
            }
        }
        `
      }
    }
  },
  noInProgress: {
    label: "No Task in progress",
    description:
      "<p>Info about Task Queue</p>",
    examples: {
        noInProgress: {
        template: code`
        <sps-task-queue [tasks]="allDoneTasks"></sps-task-queue>
        `,
        class: code`
        class DemoComponent {
            allDoneTasks: SpsTask[] = [
                {
                    status: SpsTaskStatus.COMPLETED,
                    unread: true,
                    heading: "Document Download - 02/21/2019",
                    subheading: "245 transactions | Expires in 2 days",
                    actions: [this.view, this.download]
                },
                {
                    status: SpsTaskStatus.ERRORED,
                    unread: true,
                    heading: "Data XREF Test.xls",
                    subheading: "Failed | Reason it failed…",
                    actions: [this.retry]
                },
                {
                    status: SpsTaskStatus.COMPLETED,
                    unread: true,
                    heading: "Document Download - 02/20/2019",
                    subheading: "240 transactions | Expires in 2 days",
                    actions: [this.view, this.download]
                },
                {
                    status: SpsTaskStatus.COMPLETED,
                    unread: true,
                    heading: "Document Download - 02/20/2019",
                    subheading: "195 transactions | Expires in 2 days",
                    actions: [this.view, this.download]
                },
                {
                    status: SpsTaskStatus.COMPLETED,
                    unread: true,
                    heading: "Document Download - 02/19/2019",
                    subheading: "225 transactions | Expires in 2 days",
                    actions: [this.view, this.download]
                },
                {
                    status: SpsTaskStatus.COMPLETED,
                    unread: true,
                    heading: "Document Download - 02/19/2019",
                    subheading: "222 transactions | Expires in 2 days",
                    actions: [this.view, this.download]
                },
                {
                    status: SpsTaskStatus.COMPLETED,
                    unread: true,
                    heading: "Document Download - 02/19/2019",
                    subheading: "245 transactions | Expires in 2 days",
                    actions: [this.view, this.download]
                },
            ];

            onClearCompleted(clearedTasks) {
                console.log(clearedTasks);
                console.log(this.tasks);
            }

            @SpsAction({ icon: "x" })
            cancel(task) {
                console.log("cancel", task);
            }

            @SpsAction({ icon: "search" })
            view(task) {
                console.log("view", task);
            }

            @SpsAction({ icon: "download-cloud" })
            download(task) {
                console.log("download", task);
            }

            @SpsAction({ icon: "refresh" })
            retry(task) {
                console.log("retry", task);
            }

            onOpen() {
                console.log("opened");
            }
        }
        `
      }
    }
  },
  noTasks: {
    label: "No Tasks",
    description:
      "<p>Info about Task Queue without tasks</p>",
    examples: {
        noTasks: {
        template: code`
        <sps-task-queue [tasks]="[]"></sps-task-queue>
        `
      }
    }
  },
  notifications: {
      label: "Task Queue Notifications",
      description: code`
        <p>
            If there are tasks in the queue, then a notification tooltip will be displayed
            whenever the notificationText input changes.
        </p>
      `,
      examples: {
          notifications: {
              template: code`
                <sps-task-queue
                    [(tasks)]="tasks"
                    [notificationText]="notification"
                    [notificationTooltipKind]="useBlueTooltip ? 'help' : 'default'"
                ></sps-task-queue>
                <sps-checkbox
                    [(ngModel)]="useBlueTooltip"
                    label="Blue tooltip"
                ></sps-checkbox>
                <sps-button (click)="changeNotificationText()">
                    Notification
                </sps-button>
              `,
              class: code`
                class DemoComponent {
                  tasks: SpsTask[] = [
                    {
                      status: SpsTaskStatus.COMPLETED,
                      unread: true,
                      heading: "Task Heading",
                      subheading: "Task subheading",
                    }
                  ];

                  notification = "";
                  nn = 0;
                  useBlueTooltip = false;

                  changeNotificationText() {
                    this.notification = \`Notification! \${this.nn++}\`;
                  }
                }
              `
          }
      }
  }
};
